import { render, staticRenderFns } from "./AddEditCompanyAnnouncement.vue?vue&type=template&id=1dc2cc84&scoped=true"
import script from "./AddEditCompanyAnnouncement.vue?vue&type=script&lang=js"
export * from "./AddEditCompanyAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./AddEditCompanyAnnouncement.vue?vue&type=style&index=0&id=1dc2cc84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2cc84",
  null
  
)

export default component.exports